import { render, staticRenderFns } from "./formal-import.vue?vue&type=template&id=bb6bf4a4&scoped=true&"
import script from "./formal-import.vue?vue&type=script&lang=js&"
export * from "./formal-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6bf4a4",
  null
  
)

export default component.exports